module.exports = (__webpack_require__(5))(577);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/rc-pagination/lib/locale/en_US.js from dll-reference react_lz
// module id = 190
// module chunks = 1